
import React, { useEffect, useState } from "react";
import "./RegalHome.scss"
import order from "../../assets/order-white.svg"
import orderOrg from "../../assets/order-orange.svg"
import homeSweet from "../../assets/homeSweet.png"
import recipe from "../../assets/recipe.svg"
import leaf from "../../assets/leaf.svg"
import heart from "../../assets/heart.svg"
import star from "../../assets/star.svg"
import img1 from "../../assets/img1.jpg"
import img2 from "../../assets/img2.jpg"
import img3 from "../../assets/img3.jpg"
import img4 from "../../assets/img4.jpg"
import img5 from "../../assets/img5.jpg"
import img6 from "../../assets/img6.jpg"
import img7 from "../../assets/img7.jpg"
import img8 from "../../assets/img8.jpg"
import img9 from "../../assets/img9.jpg"
import img10 from "../../assets/img10.jpg"
import img11 from "../../assets/img11.jpg"
import img12 from "../../assets/img12.jpg"
import img13 from "../../assets/img13.jpg"
import img14 from "../../assets/img14.jpg"
import img15 from "../../assets/img15.jpg"
import img16 from "../../assets/img16.png"
import menu from "../../assets/menu.svg"
import Contact from "../../components/Contact/Contact";
import Carousel from "../../components/Carousel/Carousel";
import { useHistory } from "react-router";
import { setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import { useDispatch } from "react-redux";




const RegalHome = () => {
    const history = useHistory()
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const data = [
        {
            "header": "Authentic Recipes",
            "content": "Traditional recipes passed down through generations",
            "icon": recipe
        }, {
            "header": "Fresh Ingredients",
            "content": "Quality ingredients sourced daily for maximum flavour",
            "icon": leaf
        }, {
            "header": "Made with Love",
            "content": "Every dish prepared with passion and care",
            "icon": heart
        }, {
            "header": "Quick & Convenient",
            "content": "Satisfying flavours, anytime you want",
            "icon": star
        }
    ]

    const menuData = [
        { "src": img1 },
        { "src": img2 },
        { "src": img3 },
        { "src": img4 },
        { "src": img5 },
        { "src": img6 },
        { "src": img7 },
        { "src": img8 },
        { "src": img9 },
        { "src": img10 },
        { "src": img11 },
        { "src": img12 },
        { "src": img13 },
        { "src": img14 },
        { "src": img15 },
        { "src": img16 },
    ]

    return (
        <div className="RegalHome">
            <div className="RegalHome-hero">
                <div className="RegalHome-hero-header">
                    Regal Sweet Mart &
                    <br />
                    Restaurant
                </div>
                <div className="RegalHome-hero-subheader">
                    sweet savouries and street food
                </div>
                <div className="RegalHome-hero-btn-cont">
                    <div className="RegalHome-hero-btn-cont-primary"
                        onClick={() => {
                            dispatch(setSelectedOrderType("collection"))
                            history.push("/menu")
                        }}>
                        <img alt="" src={order} />
                        Click & Collect
                    </div>
                    <div className="RegalHome-hero-btn-cont-secondary"
                        onClick={() => {
                            history.push("/page/menu")
                        }}>
                        <img alt="" src={orderOrg} />
                        View Menu
                    </div>
                </div>
            </div>
            <div className="RegalHome-container">
                <div className="RegalHome-container-hero">
                    <div className="RegalHome-container-header">
                        Welcome to Regal Sweet Mart
                    </div>
                    <div className="RegalHome-container-line" />
                    <div className="RegalHome-container-hero-cont">
                        <div className="RegalHome-container-hero-cont-left">
                            <div className="RegalHome-cont-content">
                                Your go-to destination for authentic Indian sweets and vibrant street food! At <b>Regal Sweet Mart</b>, we create joyful moments for families and friends with traditional Indian flavours and a lively, welcoming atmosphere. Whether you’re celebrating special moments or enjoying everyday treats, happiness is always served fresh at Regal.  </div>
                            <div className="RegalHome-cont-recipe">
                                <div className="RegalHome-cont-recipe-header">
                                    Our timeless recipe:
                                </div>
                                <div className="RegalHome-cont-recipe-content">
                                    Quality ingredients + Authentic taste + Love = Pure happiness
                                </div>
                            </div>
                        </div>
                        <img className="RegalHome-container-hero-cont-right"
                            alt=""
                            src={homeSweet} />

                    </div>
                    <div className="RegalHome-container-hero-grid">
                        {data?.map((item, key) => {
                            return (
                                <div className="RegalHome-container-hero-grid-item"
                                    key={key}>
                                    <div className="RegalHome-container-hero-grid-item-icon">
                                        <img alt="" src={item?.icon} />
                                    </div>
                                    <div className="RegalHome-container-hero-grid-item-header">{item?.header}</div>
                                    <div className="RegalHome-container-hero-grid-item-sub">{item?.content}</div>


                                </div>
                            )
                        })}

                    </div>
                </div>
                <div className="RegalHome-container-menu">
                    <div className="RegalHome-container-header">
                        Made with Love
                    </div>
                    <div className="RegalHome-container-line" />
                    <div className="RegalHome-container-content" >
                        Explore our delicious selection of authentic Indian street food, crafted with passion
                        and served with love
                    </div>
                    {window.screen.width > 1200 ? <div className="RegalHome-container-menu-grid">
                        {menuData.map((data, key) => {
                            return (
                                <img alt="" src={data?.src} key={key}
                                    className="RegalHome-container-menu-grid-img" />
                            )
                        })}
                    </div> : <Carousel images={menuData} />}
                    <div className="RegalHome-container-menu-btn"
                        onClick={() => {
                            history.push("/page/menu")
                        }}>
                        <img alt="" src={menu} />View Full Menu</div>
                </div>
                <div className="RegalHome-container-collect">
                    <div className="RegalHome-container-collect-header">Ready to Taste Tradition?</div>
                    <div className="RegalHome-container-collect-content">Enjoy the sweetness of convenience — order online and experience Regal’s flavours anytime.</div>
                    <div className="RegalHome-container-collect-secondary"
                        onClick={() => {
                            dispatch(setSelectedOrderType("collection"))
                            history.push("/menu")
                        }}>
                        <img alt="" src={orderOrg} />
                        Click & Collect
                    </div>
                </div>
                <div className="RegalHome-container-contact">
                    <Contact />
                </div>
            </div>
            <div className="RegalHome-hero-btn-cont-fixed">
                <div className="RegalHome-hero-btn-cont-fixed-primary"
                    onClick={() => {
                        dispatch(setSelectedOrderType("collection"))
                        history.push("/menu")
                    }}>
                    <img alt="" src={order} />
                    Click & Collect
                </div>
                <div className="RegalHome-hero-btn-cont-fixed-secondary"
                    onClick={() => {
                        history.push("/page/menu")
                    }}>
                    <img alt="" src={orderOrg} />
                    View Menu
                </div>
            </div>
        </div>
    )
}
export default RegalHome